
const x = 1
let baseUrl


if (x === 1) {

  baseUrl  = "https://fityanulislam.mmt-ng.com"
}else{

    baseUrl  = "http://localhost:8700"
}



module.exports =  baseUrl